import React from "react";
import LoaderButton from "../LoaderButton";
import { TEXT_MATCH_MODES } from "./searchModes";

/**
 * Text Search criteria: words to find in the OCR text, how to match them, and whether the viewer should highlight
 * them. Global or restricted to one template depending on the scope bar.
 */
export default function TextSearchPanel({
  query,
  matchMode,
  highlightInViewer,
  templateName,
  templateDisplayName,
  isLoading,
  onQueryChange,
  onMatchModeChange,
  onHighlightChange,
  onSubmit,
  onReset,
}) {
  const canSubmit = Boolean(query && query.trim()) && !isLoading;
  return (
    <form
      id="textSearchControls"
      className="ds-panel ds-criteria"
      autoComplete="off"
      onSubmit={(event) => {
        event.preventDefault();
        if (canSubmit) onSubmit();
      }}
    >
      <div className="ds-panel-heading">
        <h2>Text search</h2>
        <p>
          Finds words inside the OCR text of the documents
          {templateName
            ? ` in the ${templateDisplayName} index template only. If its files have no OCR text, nothing is found.`
            : " across every index template you can access (global search). Templates without OCR text return no results."}
        </p>
      </div>

      <div className="ds-field">
        <label htmlFor="textSearchQuery">Words or phrase</label>
        <div className="ds-input-with-icon">
          <svg aria-hidden="true" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <circle cx="11" cy="11" r="7" />
            <path d="M20 20l-4-4" />
          </svg>
          <input
            id="textSearchQuery"
            type="text"
            className="ds-input"
            value={query || ""}
            placeholder="Words or a phrase from the documents"
            onChange={(event) => onQueryChange(event.target.value)}
          />
        </div>
      </div>

      <fieldset className="ds-fieldset">
        <legend>Match</legend>
        {TEXT_MATCH_MODES.map((option) => (
          <label key={option.value} className="ds-radio">
            <input
              type="radio"
              name="textSearchMatchMode"
              value={option.value}
              checked={(matchMode || "all") === option.value}
              onChange={() => onMatchModeChange(option.value)}
            />
            {option.label}
          </label>
        ))}
      </fieldset>

      <label className="ds-checkbox">
        <input
          type="checkbox"
          checked={highlightInViewer !== false}
          onChange={(event) => onHighlightChange(event.target.checked)}
        />
        Highlight the matches when a file opens in the viewer
      </label>

      <div className="ds-note">
        <strong>Global or restricted?</strong> Leave the scope bar on{" "}
        <em>All index templates</em> to search everything you can access, or pick
        one template to restrict the search to it. Results from different
        templates show their template name.
      </div>

      <div className="ds-actions">
        <LoaderButton
          block
          bsClass="btn"
          disabled={isLoading}
          type="submit"
          isLoading={isLoading}
          text="Search"
          loadingText="Searching..."
          className="ds-btn-primary searchResetbutton"
        />
        <button
          type="button"
          className="btn ds-btn-secondary searchResetbutton"
          onClick={onReset}
        >
          Reset
        </button>
      </div>
    </form>
  );
}
